var _g, _path, _rect, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCredits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_5029_1978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.970703 19.2308C0.970703 8.6099 9.58061 0 20.2015 0H58.663C69.2839 0 77.8938 8.60991 77.8938 19.2308V57.6923C77.8938 68.3132 69.2839 76.9231 58.663 76.9231H0.970703V19.2308Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.35532 19.2308C1.35532 8.82232 9.79303 0.384615 20.2015 0.384615H58.663C69.0714 0.384615 77.5091 8.82232 77.5091 19.2308V57.6923C77.5091 68.1007 69.0714 76.5384 58.663 76.5384H1.35532V19.2308Z",
    stroke: "white",
    strokeWidth: 0.769231
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 21,
    width: 34,
    height: 34,
    rx: 6,
    fill: "#06DDF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30H30C28.8954 30 28 30.8954 28 32V44C28 45.1046 28.8954 46 30 46H48C49.1046 46 50 45.1046 50 44V32C50 30.8954 49.1046 30 48 30Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 36H50",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_5029_1978",
    x: -2.10622,
    y: 0,
    width: 83.0767,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.07692,
    dy: 3.07692
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.5385
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.85098 0 0 0 0 0.901961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5029_1978"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.07692,
    dy: 3.07692
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.5385
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_5029_1978",
    result: "effect2_innerShadow_5029_1978"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredits);
export default __webpack_public_path__ + "static/media/credits.0f2ab7b33d124a904e23ff6d209fef6f.svg";
export { ForwardRef as ReactComponent };